import React from "react";
import Csrd from "../component/Csrd";

function CsrdContainer() {
  return <Csrd />;
}

export default CsrdContainer;
